import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import App from './App';
import { AuthProvider } from './contexts/JWTContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material';
import { Logger } from './utils/logger';
import { VendorProvider } from './contexts/VendorContext';
import { VendorBoothProvider } from './contexts/VendorBoothContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
const container = document.getElementById('root');
const root = createRoot(container!);

window.onerror = function (msg, url, line, col, error: Error) {
  //Log uncuaght errors that may bubble up.
  Logger.error(msg, url, line, col, error);
};

root.render(
  <StrictMode>
    <SnackbarProvider>
      <HelmetProvider>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <VendorProvider>
              <VendorBoothProvider>
                <SettingsProvider>
                  <BrowserRouter>
                    <AuthProvider>
                      <App />
                    </AuthProvider>
                  </BrowserRouter>
                </SettingsProvider>
              </VendorBoothProvider>
            </VendorProvider>
          </LocalizationProvider>
        </StyledEngineProvider>
      </HelmetProvider>
    </SnackbarProvider>
  </StrictMode>
);
